/** Logical rendering constants. See ARCHITECTURE.md §1. */
export const GAME_W = 640;
export const GAME_H = 360;
export const TILE = 32;
export const FIXED_STEP_MS = 1000 / 60;

/** Depth bands. World objects use WORLD_BASE + feetY. */
export const Depth = {
  GROUND: 0,
  GROUND_DETAIL: 100,
  WORLD_BASE: 1000,
  OVERHEAD: 20000,
  WEATHER: 30000,
  LIGHTING: 31000,
  UI: 40000,
} as const;

export const GAME_TITLE = '南天传说';
export const CHAPTER_TITLE = '南洋行';
export const SAVE_VERSION = 1;
export const SAVE_PREFIX = 'nantian.save.';
export const SETTINGS_KEY = 'nantian.settings';

/** Bundled OFL subset fonts (public/assets/fonts/fonts.css). */
export const FONT_BODY = '"Nantian Sans", "Noto Sans SC", "PingFang SC", sans-serif';
export const FONT_TITLE = '"Nantian Serif", "Noto Serif SC", serif';
export const FONT_DISPLAY = '"Nantian Display", "Nantian Serif", serif';
